/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-26 14:27:27                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 14:47:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * TechnicianOptionSelectDetails: Technician detailed options
*/

/* Imports */
import { t } from "i18next";
import { Typography } from "@material-tailwind/react";
import { components } from "react-select";
import { secondsToStringTime, toSinceString } from "../../../services/utils/utils";
/***/


import "./TechnicianOptionSelectDetails.scss";
/**
* TechnicianOptionSelectDetails: Technician detailed options
* Used to display technician details in the technician select component.
* @param value - option value
* @param label - option label
*/
export default function TechnicianOptionSelectDetails(props: any) {
  
  return (
    <components.Option {...props}>
      {props.detailed ?
        <div className={"flex items-center justify-between "+(props.value.unavail && "border-t-2 border-cyan-200 !pt-2")}>
          <div className="flex flex-col">
            <Typography variant="small"
                        className="text-gray-900">
              {props.label}
            </Typography>

            {props.value.itinerary && props.value.itinerary.travelTime &&
              <Typography variant="small"
                          className="text-gray-900">
                {secondsToStringTime(props.value.itinerary.travelTime.inSeconds)} &middot; {props.value.itinerary.distance.humanReadable}
              </Typography>
            }
          </div>

          {props.value.itinerary &&
            <Typography variant="small"
                        className="text-gray-500">
              {t("about:app.updated")} {toSinceString(props.value.itinerary.updated)}
            </Typography>
          }

        </div>
      : <Typography variant="small">{props.label}</Typography>}
    </components.Option>
  );
}
/***/
